import styled, {css} from 'styled-components';
import { FONTS, COLORS } from '@app/src/ui';
import { RadioInput } from '../RadioInput/RadioInput';

interface ListItem {
  showFirstItems?: number;
}

interface Item {
  activeSuggestion?: boolean;
}

interface Wrapper {
  borderColor?: string;
}

export const InputWrapper = styled.input`
  width: 100%;
  outline: none;
  margin: 0;
  font-size: 14px;
  color: ${COLORS.BLACK};
  border: none;
  line-height: 22px;
  font-family: ${FONTS.OPEN_SANS};
  &::placeholder {
    color: ${COLORS.GRAY_PLACEHOLDER};
  }
`;

export const Content = styled.div`
  position: relative;
`;

export const Wrapper = styled.div`
  background: #fff;
  height: 44px;
  border-radius: 4px;
  position: relative;
  box-sizing: border-box;
  display: block;
  input {
    position: absolute;
    padding: 10px 40px 10px 38px;
    z-index: 2;
    background: transparent;
    width: 100%;
  }
  ${(props: Wrapper) => props.borderColor && `border: ${props.borderColor}`};
`;

export const IconWrapper = styled.span`
  position: absolute;
  top: 13px;
  left: 12px;
  z-index: 3;
`;

export const IconClose = styled.span`
  position: absolute;
  right: 12px;
  top: 13px;
  cursor: pointer;
  z-index: 2;
`;

export const List = styled.ul`
  font-family: ${FONTS.OPEN_SANS};
  font-weight: 400;
  font-size: 16px;
  line-height: 17px;
  background: #fff;
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  width: 100%;
  padding: 0;
  list-style: none;
  overflow-y: scroll;
  max-height: 215px;
  z-index: 1;
  position: absolute;
  top: 44px;
  &::-webkit-scrollbar {
    width: 4px;
    background-color: ${COLORS.GRAY};
  }
  &::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: ${COLORS.GRAY_PLACEHOLDER};
  }
  &::-webkit-scrollbar-track{
    border-radius: 10px;
    background-color: #fff;
  }
  ${(props: ListItem) => props.showFirstItems && css`
    max-height: ${props.showFirstItems * 44}px;
  `};
`;

export const ListModel = styled(List)`
  position: relative;
  top: 0;
`;

export const Item = styled.li`
  display: flex;
  align-items: center;
  outline: none;
  min-height: 44px;
  cursor: pointer;
  :hover {
    background: aliceblue;
    color: ${COLORS.BLACK};
  }
  &:focus {
    background: aliceblue;
    color: ${COLORS.BLACK};
  }
  ${(props: Item) =>
    props.activeSuggestion &&
    css`
      background: aliceblue;
      color: ${COLORS.BLACK};
    `};
  p {
    font-size: 14px;
    color: ${COLORS.GRAY_DARK};
  }
  span {
    font-size: 16px;
    color: ${COLORS.BLACK};
  }
`;

export const Description = styled.div`
  padding: 0 12px;
`;

const TextPredictive = `
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-right: 20px;
  font-family: ${FONTS.OPEN_SANS};
  color: ${COLORS.GRAY_DARK };
  font-size: 14px;
  position: absolute;
  span {
    font-size: 16px;
    pointer-events: none;
  }
`;

export const Placeholder = styled.p`
  ${TextPredictive};
  padding: 10px 12px 10px 38px;
  line-height: 22px;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  opacity: .7;
`;

export const Ubigeo = styled.p`
  ${TextPredictive};
  top: 11px;
  left: 38px;
  width: calc(100% - 50px);
  z-index: 1;
  span {
    color: ${COLORS.BLACK};
  }
`;

export const ContentModal = styled.div`
  width: 280px;
  min-height: 80px;
`;

export const ListOptionModal = styled.ul`
  background: #fff;
  border-radius: 3px;
  width: 280px;
  & li:nth-child(2) {
    display: none;
  }
`;

export const ModalTitle = styled.h3`
  font-family: ${FONTS.OPEN_SANS};
  font-weight: 600;
  font-size: 14px;
  padding: 0 15px;
  line-height: 44px;
`;

export const RadioInputWrapper = styled(RadioInput)`
  display: flex;
  width: 100%;
  padding: 0 12px;
  min-height: 44px;
  justify-content: space-between;
  :hover {
    background: aliceblue;
    color: ${COLORS.BLACK};
  }
  &:focus {
    background: aliceblue;
    color: ${COLORS.BLACK};
  }
  ${(props: Item) =>
    props.activeSuggestion &&
    css`
      background: aliceblue;
      color: ${COLORS.BLACK};
    `};
  p {
    font-size: 14px;
    color: ${COLORS.GRAY_DARK};
  }
  span {
    font-size: 16px;
    color: ${COLORS.BLACK};
  }
`;

export const ErrorMessage = styled.span`
  color: red;
  font-size: 11px;
`;

export const LoaderWrapper = styled.span`
  right: 12px;
  top: 10px;
  position: absolute;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`

export const NotResults = styled.p`
  padding: 15px;
`;